import { getUrlVars } from '../../Utils'
import { formHelp } from './formHelpers'
import { ValidatorMetaMap } from './formInterfaces'

export const fieldSetValidation = {
    isFieldType: function (field: { [s: string]: any }) {
        return (
            field.id !== undefined &&
            field.name !== undefined &&
            field.type !== undefined &&
            field.value !== undefined &&
            field.empty !== undefined &&
            field.required !== undefined &&
            field.domain !== undefined &&
            field.help !== undefined
        )
    },
    // fieldStatus: function (
    //     addAuditComment: (s: string) => void,
    //     schemataSections: { [s: string]: any }[],
    //     validatorMetaMap: { [s: string]: any },
    //     templateType: string,
    //     field: { [s: string]: any },
    //     fieldset: { [s: string]: any }
    // ) {
    //     if (formHelp.isEmptyField(field) && field.required) return formHelp.REQUIRED
    //     return !formHelp.isEmptyField(field)
    //         ? fieldSetValidation.isValidField(
    //               addAuditComment,
    //               schemataSections,
    //               validatorMetaMap,
    //               templateType,
    //               field,
    //               fieldset
    //           )
    //             ? formHelp.COMPLETED
    //             : formHelp.INVALID
    //         : field.required
    //           ? formHelp.REQUIRED
    //           : formHelp.OPTIONAL
    // },
    fieldValidity: function (field: { [s: string]: any }, fieldset: { [s: string]: any }) {
        return field.validator ? field.validator(field, fieldset) || {} : false
    },
    hasFieldIndex: function (field: { [s: string]: any }) {
        return field.fieldIndex && field.fieldIndex.length > 0
    },
    // TODO: it seems like these functions are no longer used
    // isValidField: function (
    //     addAuditComment: (s: string) => void,
    //     schemaSections: { [s: string]: any }[],
    //     validatorMetaMap: ValidatorMetaMap,
    //     templateType: string,
    //     field: {
    //         [x: string]: any
    //         disp?: any
    //         fieldIndex?: any
    //         value?: any
    //         required?: any
    //         validator?: any
    //         name?: any
    //     },
    //     fieldset: any,
    //     setIndex: any = 0
    // ) {
    //     //if (field.id == "6986" || field.id == "9500" || field.id == "9505" || field.id == "9510")
    //     //    return true; // Skip Medication Validation. Deal with this later.
    //     const isField = fieldSetValidation.isFieldType(field)
    //     let isValid
    //     if (!isField) return isField
    //     const disp = (field.disp = formHelp.isDependencyOk(
    //         true,
    //         field,
    //         setIndex ? setIndex : 0,
    //         schemaSections,
    //         validatorMetaMap,
    //         templateType,
    //         fieldset,
    //         null,
    //         addAuditComment
    //     ))

    //     if (disp === false) return true

    //     if (fieldSetValidation.hasFieldIndex(field)) {
    //         console.error("need to correctly update field.value at the context level")
    //         field.fieldIndex.map(function (fv: any) {
    //             field.value = fv
    //         })
    //     }

    //     if (formHelp.isEmptyField(field)) {
    //         if (!field.required) isValid = true
    //         else isValid = false
    //     } else if (!field.validator) {
    //         if (formHelp.isYesNoField(field, 0) > 0) isValid = true
    //         else isValid = field.value !== null
    //     } else {
    //         var v = field.validator(field, fieldset)
    //         isValid = true
    //         if (v) {
    //             if (!v.warning && v.issue) {
    //                 isValid = false
    //             }
    //         }
    //         // if (validityTrace && !isValid) console.log("   NEED " + field.id + " " + field.name);
    //         // if (!isValid) App.reqFieldStatus("Next required field is [" + field.id + "] " + field.name);
    //     }
    //     return isValid
    // },
    // schemataMap => window.schemataFormMap?.schemataMap
    // validatorMetaMap => window.schemataFormMap?.validatorMetaMap
    // templateType => window.schemataFormMap?.templateType
    // isValidFieldSet: function (
    //     fieldset: { fields: any[] | undefined },
    //     schemataSections: { [s: string]: any }[],
    //     validatorMetaMap: ValidatorMetaMap,
    //     templateType: string,
    //     addAuditComment: (s: string) => void
    // ) {
    //     function sofar(
    //         ok: any,
    //         field: {
    //             [x: string]: any
    //             disp?: any
    //             fieldIndex?: any
    //             value?: any
    //             required?: any
    //             validator?: any
    //             name?: any
    //         }
    //     ) {
    //         return (
    //             ok &&
    //             fieldSetValidation.isValidField(
    //                 addAuditComment,
    //                 schemataSections,
    //                 validatorMetaMap,
    //                 templateType,
    //                 field,
    //                 fieldset
    //             )
    //         )
    //     }

    //     return (
    //         fieldset.fields !== undefined &&
    //         fieldset.fields.length > 0 &&
    //         fieldset.fields.reduce(sofar, true)
    //     )
    // },
}
